import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import router from './config/router'
import { Toaster } from 'react-hot-toast'
import 'react-toastify/dist/ReactToastify.css'
import './index.css'
import { AuthProvider } from './features/auth/context/auth/AuthProvider'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Toaster
        position="top-left"
        reverseOrder={false}
      />
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>,
)
